<template>
<div v-loading="loading">
  <div class="hello" v-show="phone=='--'||!phone">
    <el-empty description="暂无用户数据" />
  </div>
</div>

</template>

<script>
import axios from 'axios';
import { reactive } from 'vue'
import {getAction,postAction, getQueryString} from "@/api/manage";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function() {
    return {
      messageInfo:"",
      url:{
        GetAgentConfig:"/api/wechatkfAPI.php?do=GetAgentConfig",
        GetUserByUserId:"/api/wechatkfAPI.php?do=GetUserByUserId"
      },
      name: '--',
      sex:'--',
      age:'--',
      phone: '--',
      jwbs:'--',
      illness:[],
      xl: {data:'-',tip:'--'},//心率
      xya:{data:'-',tip:'--'},//血压
      yd:{data:'-',tip:'--'},//运动
      sm:{data:'-',tip:'--'},//睡眠
      xy:{data:'-',tip:'--'},//血氧
      ydxh:{data:'-',tip:'--'},//运动消耗
      xt:{data:'-',tip:'--'},//血糖
      xz:{data:'-',tip:'--'},//血脂
      ns:{data:'-',tip:'--'},//尿酸
      loading:true,
      type:0,
      wechatId:2
    };
  },
  created() {
    if(this.$route.query.type){
      this.type=this.$route.query.type;
    }
    if(this.$route.query.wechatId){
      this.wechatId=this.$route.query.wechatId;
    }
    this.url.GetAgentConfig=this.url.GetAgentConfig+"&wechatId="+this.wechatId;
    this.url.GetUserByUserId=this.url.GetUserByUserId+"&wechatId="+this.wechatId;
    this.send();
  },

  methods: {

    //发送
    send() {
      var that = this;
      const fullPath = window.location.href;
      var params ={url:fullPath};
      getAction(this.url.GetAgentConfig, params).then((res) => {
        soianWX.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.config.corpid, // 必填，企业微信的corpID
          timestamp: res.data.config.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.config.nonceStr, // 必填，生成签名的随机串
          signature: res.data.config.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: [ 'getContext', 'getCurExternalContact'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        soianWX.ready(function() {
          that.messageInfo=that.messageInfo+":注入验证成功了";
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          that.getCon(res.data.yyconfig);
        });
      })

    },
    getCon(data) {
      var that = this;
      soianWX.agentConfig({
        corpid: data.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data.agentid, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: ['getContext', 'getCurExternalContact'], //必填
        success: function(res2) {
          that.messageInfo=that.messageInfo+":agentConfig注入成功了";
          //获取外部联系人id
          soianWX.invoke('getCurExternalContact', {}, function(res5) {
            that.messageInfo=that.messageInfo+":外部联系人id获取啦"+JSON.stringify(res5, null, 2);;;
            console.log(res5);
            if (res5.err_msg == 'getCurExternalContact:ok') {
              that.messageInfo=that.messageInfo+":外部联系人id："+res5.userId;
              that.getCurUserInfo(res5.userId);
              that.couId = res5.userId; //返回当前外部联系人userId

            } else {
              //错误处理
            }
          });
        },
        fail: function(err) {
          that.messageInfo=that.messageInfo+":agentConfig失败："+JSON.stringify(err, null, 2); ;
          console.log(err);
        }
      });
    },
    getCurUserInfo(userId){
      var that = this;
      let params={userId:userId,wechatId:this.wechatId}
      getAction(this.url.GetUserByUserId, params).then((res) => {
        that.loading=false;
        that.phone=res.data.user.phone;
        if(that.phone){
          if(that.type==0){
            this.$router.push({name:'User',query: {phone:that.phone,wechatId:that.wechatId}})
          }else if(that.type==1){
            this.$router.push({name:'JfExchange',query: {phone:that.phone,wechatId:that.wechatId}})
          }
        }


        that.messageInfo=that.messageInfo+":用户手机号："+res.data.user.phone;

      })
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  height: 106px;
}
.textHeight{
  line-height: 18px;
}
.xueya{
  background-image: url("/src/static/dt/血压.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.yundong{
  background-image: url("/src/static/dt/步数.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xinlv{
  background-image: url("/src/static/dt/心率.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.shuimian{
  background-image: url("/src/static/dt/睡眠.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xueyang{
  background-image: url("/src/static/dt/血氧.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.yundongxiaohao{
  background-image: url("/src/static/dt/运动消耗.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xuetang{
  background-image: url("/src/static/dt/血糖.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xuezhi{
  background-image: url("/src/static/dt/血脂.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.niaosuan{
  background-image: url("/src/static/dt/尿酸.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.xueya-error{
  background-image: url("/src/static/dt-error/血压.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.yundong-error{
  background-image: url("/src/static/dt-error/步数.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xinlv-error{
  background-image: url("/src/static/dt-error/心率.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.shuimian-error{
  background-image: url("/src/static/dt-error/睡眠.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xueyang-error{
  background-image: url("/src/static/dt-error/血氧.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.yundongxiaohao-error{
  background-image: url("/src/static/dt-error/运动消耗.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xuetang-error{
  background-image: url("/src/static/dt-error/血糖.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.xuezhi-error{
  background-image: url("/src/static/dt-error/血脂.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.niaosuan-error{
  background-image: url("/src/static/dt-error/尿酸.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.el-main {
  --el-main-padding: 17px;
  box-sizing: border-box;
  display: block;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  padding: var(--el-main-padding);
  padding-right: -29px;
  margin-right: -59px;
}
</style>
